export default () => ({
  showPopover: false,
  setPopoverPosition: function () {
    const buttonBoundingRect = this.$el.getBoundingClientRect();
    const tableBoundingRect = this.$refs.biddingTable.getBoundingClientRect();

    const { x, y } = buttonBoundingRect;
    const offset = 15;
    const top = y - tableBoundingRect.y + offset;
    const left = x - tableBoundingRect.x + offset;

    this.$refs.popover.style.top = `${top}px`;
    this.$refs.popover.style.left = `${left}px`;
  },
});
